import type { Address } from '@/modules/address/domain/Address';
import type { PlaceData } from '@/sections/region/GooglePlaceDataContext';

const clearLocationData = (address: Address): Address => {
  return {
    ...address,
    latitude: 0,
    longitude: 0,
    lat: 0,
    lon: 0,
    plusCode: '',
    postalCode: ''
  };
};

export const getPayloadForCustomerAddress = (
  address: Address,
  placeData: PlaceData | null
) => {
  const newLatitude = placeData?.place?.latitude;
  const newLongitude = placeData?.place?.longitude;

  if (address?.isAutocomplete) {
    if (newLatitude && newLongitude) {
      address.lat = newLatitude;
      address.lon = newLongitude;
      address.plusCode = placeData?.place?.plus_code;
      address.postalCode = placeData?.place?.postal_code;
    }

    if (address?.latitude && address?.longitude) {
      address.lat = address?.latitude;
      address.lon = address?.longitude;
    }
  }

  if (address?.isAutocomplete === false) {
    address = clearLocationData(address);
  }

  if (address?.lat && address?.lon) {
    address.latitude = undefined;
    address.longitude = undefined;
  }

  const streetNameUntilFirstComma = address?.streetName?.split(',')?.[0];
  address.streetName = streetNameUntilFirstComma || address?.streetName;

  return address;
};
